import React, { PureComponent } from 'react';
import BasketInfo from './basketinfo';
import BasketSummary from './basketsummary';
import BasketDetails from './basketdetails';
import Progressbar from '../shared/progressbar';
import Header from '../shared/header';
import Footer from '../shared/footer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchProduct } from '../../actions/product';
import { FetchNationality } from '../../actions/nationality';
// import Promocode from './components/promocode';
import { initialize, getFormValues } from 'redux-form';
import ReactModal from 'react-modal';
import { currencySign, renderProductTitle } from '../../helpers/utils';
import BasketDeparture from './basketdeparture';
import CapacityModal from './components/capacitymodal';
import { SetProcessing, SetLockout } from '../../actions/currentBooking';
import { BookingError } from '../../actions/booking';
import { FetchLiveCapacity } from '../../actions/capacity';
import { ProductDetailsView } from '../../actions/analytics';
import { FetchUpgrades } from '../../actions/upgrades';
import _forEach from 'lodash/forEach';
import ReactGA from 'react-ga';
import Spinner from '../shared/spinner';
import { upgradesName } from '../../helpers/upgradesHelper';

import dayjs from 'dayjs';

const queryString = require('query-string');

class Basket extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      departModalAdultPrice:"",
      departModal:false
    }
    this.openDepartModal = this.openDepartModal.bind(this);
    this.closeDepartModal = this.closeDepartModal.bind(this);
    this.onDepartAfterOpen = this.onDepartAfterOpen.bind(this);
  }

  openDepartModal(){
    ReactGA.pageview('book.busabout.com/modal/basket-depart-modal');
    this.setState({departModal:true, departModalAdultPrice:this.props.product.header.prices_from.adult});
  }
  closeDepartModal(){
    this.setState({departModal:false});
    this.props.BookingError();
    this.props.SetLockout(false);
  }



  componentDidMount(){

    const { FetchProduct, match:{params}, FetchNationality, currency } = this.props;

    //Change document title
    document.title = "Book your adventure - Departure";

    // Scroll window to top
    window.scrollTo(0, 0);

    this.populateBasketPaxDetails();

    // FetchProduct and FetchNationality if currency is in store
    if(Object.keys(currency).length !== 0){
      FetchProduct(params.tourID, currency.iso_currency_code, true, true);
      FetchNationality();
    }


  }

  populateBasketPaxDetails(){

    //populate basket values
    this.props.initialize("BasketPax",this.props.basketPaxValues);

    //prefill input
    _forEach(document.querySelectorAll('.basket-pax-details input'),item => {
      if(item.value !== "") item.parentElement.parentElement.classList.add('hovered');
    });

  }


  componentDidCatch(error, info) {
    this.props.history.push('/');
  }

  componentDidUpdate(prevProp, prevState){

    const {
      FetchProduct,
      match:{params},
      FetchNationality,
      product,
      currency,
      FetchUpgrades
    } = this.props;
    const qs = queryString.parse(window.location.search);

    // Get product data from products API
    if(currency !== prevProp.currency){
      FetchProduct(params.tourID, currency.iso_currency_code, true, true);
      FetchNationality();

      //Get upgrade name 
      if(qs.bundle !== undefined) FetchUpgrades(params.tourID, currency.iso_currency_code);
    }


    // Tracking
    if(product !== prevProp.product){
      ProductDetailsView(product.header)
    }

  }


  onDepartAfterOpen(){

    const {
      SetProcessing,
      currency:{ iso_currency_code },
      FetchLiveCapacity,
      currentTrip:{tour_id, city_id, departure_date}
     } = this.props;


     //Set processing preloader
     SetProcessing(true);

     //check live capacity
     FetchLiveCapacity(
       tour_id,
       iso_currency_code,
       city_id,
       dayjs(departure_date).format("YYYY"),
       dayjs(departure_date).format("MM"),
       dayjs(departure_date).format("DD")
     );

  }


  render() {

    const {
      product,
      product: { redirect },
      match: { params },
      currency,
      nationality,
      currentTrip: { tour_id },
      processing,
      booking,
      capacity,
      lockout,
      upgrades
    } = this.props;


    if(redirect){
      return <Spinner text="Loading..." loadClass="search-loading-spinner" />
    }
    else{
      return (
          <React.Fragment>
            <Header />
            <Progressbar tourId={product.header.tour_id}/>
            <div className="basket">
              <BasketInfo product={product} currency={currency} capacity={capacity} upgradesName={upgradesName(upgrades)} />

              <div className="row">
                <div className="column small-12 large-11 large-offset-0-5">

                <div className="row">
                    <div className="column small-12 medium-7 large-8 col-left-mod">
                      <BasketDetails basketdetailsclass=""  routeParams={params} />
                    </div>
                    <div className="column small-12 medium-5 large-4 col-right-mod">
                        <BasketSummary basketsummaryclass="" onContinue={this.openDepartModal} basketType={""}/>
                    </div>
                  </div>
              </div>
            </div>

            </div>
            <Footer />



            <ReactModal
                  className="depart-modal"
                  overlayClassName="modal-overlay white scroll"
                  isOpen={this.state.departModal}
                  onRequestClose={this.closeDepartModal}
                  onAfterOpen={this.onDepartAfterOpen}
                  contentLabel="Depart modal">

                 <div className="depart-container">

                    <div className="row">
                      <div className="column small-12">

                      <div className="basket-depart-wrapper">

                        <div className="basket-depart-noloader">
                          <BasketDeparture
                            headerText={renderProductTitle(product, tour_id)}
                            headerCurrency={currencySign(currency.currency_mask)}
                            headerPrice={this.state.departModalAdultPrice}
                            nationality={nationality}
                            basketType=""
                            lockout={lockout}
                           />

                          </div>

                          <div className="basket-depart-loader" style={{display:(processing || booking) ? "block": "none"}}>
                            <div className="basket-depart-loader-container">
                                <CapacityModal basketType="" />
                            </div>
                          </div>

                        </div>

                        <button className="modal-close orange" onClick={this.closeDepartModal}>
                          <span className="fa fa-times fa-2x"></span>
                        </button>

                      </div>
                    </div>

                 </div>
            </ReactModal>


          </React.Fragment>
        );
    }
  }
}



 function mapStateToProps(state){
   return {
     currency:state.currency,
     product:state.product,
     nationality:state.nationality,
     basketPaxValues:getFormValues('BasketPax')(state),
     currentTrip:state.currentBooking.trips[0],
     processing:state.currentBooking.processing,
     booking:state.currentBooking.booking,
     capacity:state.capacity.data,
     lockout:state.currentBooking.lockout,
     upgrades:state.upgrades.data
   }
 }

 function mapDispatchToProps(dispatch){
   return bindActionCreators({
     FetchProduct,
     FetchNationality,
     FetchLiveCapacity,
     initialize,
     SetProcessing,
     BookingError,
     SetLockout,
     FetchUpgrades
   }, dispatch);
 }

 export default connect(mapStateToProps, mapDispatchToProps)(Basket);



// WEBPACK FOOTER //
// ./src/components/basket/basket.js